export default {
    path: 'admin_invoice',
    component: () => import(/* webpackChunkName: "common-list" */ '@/pages/examine/ExamineList'),
    meta: {title:'开票审核',cate:'所有商户管理'},
    children: [
        {
            path: 'detail',
            component: () => import(/* webpackChunkName: "article-create" */ '@/pages/common/invoiceDetails'),
            meta: { title: '申请详情' },
        },
    ]
}